import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import { FI18n } from '@freelog/tools-lib';
import { connect } from 'dva';
import { ConnectState, ResourceCreatorBatchPageState } from '@/models/connect';
import { Dispatch } from 'redux';
import { ChangeAction } from '@/models/resourceCreatorBatchPage';
import FHotspotTooltip, {
  fSetHotspotTooltipVisible,
} from '@/components/FHotspotTooltip';
import * as AHooks from 'ahooks';
import FResourceTypeInput4 from '@/components/FResourceTypeInput4';
import FIcons from '@/components/FIcons';

interface ResourceTypeProps {
  dispatch: Dispatch;
  resourceCreatorBatchPage: ResourceCreatorBatchPageState;
}

function ResourceType({
  resourceCreatorBatchPage,
  dispatch,
}: ResourceTypeProps) {
  AHooks.useDebounceEffect(
    () => {
      if (!!resourceCreatorBatchPage.selectedResourceType) {
        fSetHotspotTooltipVisible(
          'batchResourceCreator.selectResourceType.submitButton',
          {
            value: true,
            effectiveImmediately: true,
            onlyNullish: true,
          },
        );
      }
    },
    [resourceCreatorBatchPage.selectedResourceType],
    {
      wait: 10,
    },
  );

  return (
    <div className={styles.container1}>
      <div style={{ height: 35 }} />
      <div className={styles.nav}>
        <div className={styles.left}>
          {FI18n.i18nNext.tAuto('brr_title_bulkreleaseresource')}
        </div>
        <div style={{ width: 10 }} />
        <div className={styles.other}>{'>'}</div>
        <div style={{ width: 7 }} />
        <div className={styles.other}>
          {FI18n.i18nNext.tAuto('brr_selectresourcetype_title')}
        </div>
      </div>
      <div style={{ height: 35 }} />
      <div className={styles.block}>
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.tAuto('brr_selectresourcetype_input_resourcetype')}
          type={'highlight'}
        />
        <div style={{ height: 5 }} />
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.tAuto(
            'brr_selectresourcetype_input_resourcetype_msg',
          )}
          type={'additional2'}
        />
        <div style={{ height: 20 }} />

        <FResourceTypeInput4
          value={resourceCreatorBatchPage.selectedResourceType}
          subjectType={'batchResources'}
          onChange={(value) => {
            dispatch<ChangeAction>({
              type: 'resourceCreatorBatchPage/change',
              payload: {
                selectedResourceType: value,
                selectedResourceType_errorText:
                  value === null
                    ? FI18n.i18nNext.tAuto(
                        'naming_convention_resource_type_required',
                      )
                    : '',
              },
            });
          }}
          showAddNewType={false}
        />
        {resourceCreatorBatchPage.selectedResourceType_errorText !== '' && (
          <>
            <div style={{ height: 5 }} />
            <div style={{ color: '#EE4040', fontSize: 12 }}>
              {resourceCreatorBatchPage.selectedResourceType_errorText}
            </div>
          </>
        )}
      </div>
      <div style={{ height: 30 }} />
      <div className={styles.footer}>
        <div>
          <FIcons.FInfo style={{ fontSize: 14 }} />
          &nbsp;{FI18n.i18nNext.tAuto('brr_selectresourcetype_msg_typelimit')}
        </div>
        <FHotspotTooltip
          id={'batchResourceCreator.selectResourceType.submitButton'}
          style={{ left: 20, bottom: -38 }}
          text={FI18n.i18nNext.tAuto('hotpots_brr_info_done')}
          onOpenChange={(o) => {
            if (o) {
              fSetHotspotTooltipVisible(
                'batchResourceCreator.selectResourceType.submitButton',
                {
                  value: false,
                  effectiveImmediately: false,
                  onlyNullish: false,
                },
              );
            }
          }}
        >
          <FComponentsLib.FRectBtn
            disabled={!resourceCreatorBatchPage.selectedResourceType}
            onClick={() => {
              dispatch<ChangeAction>({
                type: 'resourceCreatorBatchPage/change',
                payload: {
                  showPage: 'uploadFile',
                },
              });
            }}
          >
            {FI18n.i18nNext.tAuto('brr_selectresourcetype_btn_next')}
          </FComponentsLib.FRectBtn>
        </FHotspotTooltip>
      </div>
    </div>
  );
}

export default connect(({ resourceCreatorBatchPage }: ConnectState) => ({
  resourceCreatorBatchPage: resourceCreatorBatchPage,
}))(ResourceType);
